import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { map } from 'rxjs';

export const NoAuthGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const authService = inject(AuthService);

  return authService.check().pipe(
    map((authenticated) => {
      if (authenticated) {
        router.navigate(['tandaplus', 'dashboard']);
        return false;
      }
      return true;
    }),
  );
};
